import React, { useEffect, useRef, useState, useCallback } from "react";
import { injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { format } from "date-fns";

import Modal from "../../../../../_artifact/components/Modal";
import jsonHelper from "../../../../../_artifact/helpers/jsonHelper";
import { translate } from "../../../../../_artifact/i18n";
import * as petsActions from "../../_redux/pets";
import { fetchPreviousTestDetails } from "../../_redux/previousTests";
import { trackingLog } from "../../../Tracking/_redux/tracking";
import * as logsPanelistsActions from "../../../Tracking/_redux/tracking";
import RedirectModel from "../../../../../_artifact/components/RedirectModel";

function Finish({ intl, history }) {
  const { state } = useSelector((state) => ({ state }), shallowEqual);
  const { testDetails } = state.previousTests;
  const { answers } = state.pets.entities;
  const { panelist_email_id, country } = state.auth.user;
  const [noResponsesError, setNoResponsesError] = useState(false);
  const [comment, setComment] = useState(testDetails?.add_comments || "");
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const selectedTest = useRef({});
  const dispatch = useDispatch();
  const isSubmitted = useRef(0);
  const [rewardURL, setRewardURL] = useState("");
  const [retryReward, setRetryReward] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [retryObj, setRetryObj] = useState(null); // Stores retry parameters

  const { trackingPayload } = useSelector(
    (state) => state.tracking,
    shallowEqual
  );

  const tryRewardFetch = useCallback(
    async (obj) => {
      setRetryObj(obj);
      setRetrying(true);
      try {
        const response = await dispatch(petsActions.getRewardLink(obj));
        const status = response?.data?.status?.toLowerCase?.();
        const url = response?.data?.url;
        if (status === "success") {
          setRewardURL(url);
          setRetryReward(false);
          setIsOpen(true); //Open final success modal
        } else {
          setRetryReward(true); //Keep showing retry modal
          if (country?.toLowerCase() === "usa") {
            toast.error(translate("TESTING.GENERAL.RETRY_REWARD", intl));
          }
        }
      } catch (error) {
        setRetryReward(true); //Show retry modal on API error
      } finally {
        setRetrying(false);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const jsonString = localStorage.getItem("selectedTest");
    const myObject = JSON.parse(jsonString);
    selectedTest.current = myObject;
    if (!myObject?.test_schedule_id) {
      history.replace("testing/codes");
    } else {
      dispatch(
        fetchPreviousTestDetails({
          panelist_id: myObject?.panelist_id,
          test_schedule_id: myObject?.test_schedule_id,
          product_id: myObject?.product_id,
          country: country,
        })
      );
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!testDetails?.product_pre_img) {
      toast.error(translate("TESTING.TOAST.PRE_POST_REQUIRED", intl));
      return;
    }

    if (!testDetails?.product_post_img) {
      toast.error(translate("TESTING.TOAST.PRE_POST_REQUIRED", intl));
      return;
    }

    var retry = 1;
    const api = () => {
      const species = selectedTest.current?.species?.toLowerCase();
      const category = selectedTest.current?.product_category?.toLowerCase();
      if (species === "cat" && category === "dry") {
        if (isSubmitted.current) return;
        isSubmitted.current = 1;
        const jsonString = localStorage.getItem("selectedTest");
        const selectedTest = JSON.parse(jsonString);
        const getQuens = localStorage.getItem("question");
        const myObject = JSON.parse(getQuens);
        const responses = myObject?.map(({ question_id, title, response }) => ({
          question_id,
          title,
          response,
        }));
        dispatch(petsActions.submitAnswers({ responses, comment }));
        const now = new Date().toISOString();
        let endTime = now;
        localStorage.setItem("end_time", endTime);
        const startTime = localStorage.getItem("postWeightStartTime");

        let ques_res = {};
        if (
          testDetails?.question_response &&
          Array.isArray(testDetails.question_response)
        ) {
          ques_res = testDetails.question_response.reduce(
            (acc, { question_id, response }) => {
              acc[question_id] = response ?? null;
              return acc;
            },
            {}
          );
        } else {
          setNoResponsesError(true);
          return; // Stop further execution
        }
        const jsonAnswer = JSON.stringify(ques_res);
        localStorage.setItem("answer", jsonAnswer);
        const values = {
          panelist_id: selectedTest.panelist_id,
          test_schedule_id: selectedTest.test_schedule_id,
          product_id: selectedTest.product_id,
          question_response: jsonAnswer,
          add_comments: comment,
          start_time: format(new Date(startTime), "yyyy-MM-dd HH:mm:ss"),
          end_time: format(new Date(endTime), "yyyy-MM-dd HH:mm:ss"),
          post_feed: 0,
          panelist_email_id: panelist_email_id,
          species: selectedTest.species,
          product_category: selectedTest.product_category,
          country: country,
        };
        const api = () => {
          dispatch(
            petsActions.saveResponseToServer(jsonHelper.jsonToForm(values))
          )
            .then(() => {
              history.push("/testing/postfeed-questionnaire");
              dispatch(
                trackingLog({
                  ...trackingPayload,
                  question_responses: jsonAnswer,
                  postweight_page: 1,
                })
              );
            })
            .catch((error) => {
              error.clientMessage = translate(
                "TESTING.TOAST.TEST_SUBMIT_FAILED",
                intl
              );
              dispatch(petsActions.catchUIError(error));
              isSubmitted.current = 0;
            });
        };

        api();
      } else {
        const jsonString = localStorage.getItem("anwserObj");
        let values = JSON.parse(jsonString);

        values.country = country;
        values.add_comments = comment;
        dispatch(petsActions.submitTest(jsonHelper.jsonToForm(values)))
          .then(() => {
            setIsOpen(true);
            let obj = {
              panelist_email_id: panelist_email_id,
              test_id: selectedTest?.current?.test_name,
              product_id: selectedTest?.current?.product_id,
            };

            tryRewardFetch(obj);
            // dispatch(petsActions.getRewardLink(obj)).then((response) => {
            //   const rewardURL = response?.data?.url;
            //   setRewardURL(rewardURL);
            // });
            dispatch(
              trackingLog({
                ...trackingPayload,
                additional_comment: comment,
                sumitted_test: 1,
                submitted_test_time: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
              })
            );
          })
          .catch((error) => {
            dispatch(
              trackingLog({
                ...trackingPayload,
                api_log:
                  error["stack"] +
                  " | Finish " +
                  format(new Date(), "yyyy-MM-dd HH:mm:ss") +
                  " |" +
                  error.message,
              })
            );
            retry++;
            if (retry < 3) {
              api();
            }
            if (retry === 3) setOpen(true);
            error.clientMessage = translate(
              "TESTING.TOAST.TEST_SUBMIT_FAILED",
              intl
            );
            dispatch(petsActions.catchUIError(error));
          });
      }
    };
    api();
  };

  return (
    <div className="inner-page">
      <div className="test-box">
        <h3 className="test-box-title desktop-only">
          {translate("TESTING.GENERAL.GREAT_JOB", intl)}
        </h3>
        <div className="finish-box">
          <div className="captured-weight">
            <div className="response-text check-arrow">
              <h4>{translate("TESTING.HEADER.PRE_WEIGHT", intl)}</h4>
              <p>{testDetails?.product_pre_wt} gms</p>
            </div>
            <div className="c-image">
              <img
                src={testDetails?.product_pre_img}
                alt={translate("TESTING.IMAGEUPLOAD.MSG", intl)}
              />
            </div>
          </div>
        </div>

        <div className="finish-box">
          <div className="response-text">
            <h4 className="check-arrow">
              {translate("TESTING.HEADER.OBSERVATION", intl)}
            </h4>
            {testDetails?.question_response?.map(
              ({ title, response }, index) => (
                <p key={index}>
                  {index + 1}. {title}: <strong>{response}</strong>
                </p>
              )
            )}
          </div>
        </div>

        <div className="finish-box">
          <div className="captured-weight">
            <div className="response-text check-arrow">
              <h4>{translate("TESTING.HEADER.POST_WEIGHT", intl)}</h4>
              <p>{testDetails?.product_post_wt} gms</p>
            </div>
            <div className="c-image">
              <img
                src={testDetails?.product_post_img}
                alt={translate("TESTING.IMAGEUPLOAD.MSG", intl)}
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>{translate("TESTING.GENERAL.COMMENTS_OPTIONAL", intl)}</label>
          <textarea
            placeholder={translate("TESTING.GENERAL.ADDITIONAL_COMMENTS", intl)}
            rows="5"
            className="form-control"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        <div>
          <button className="btn btn-primary btn-block" onClick={handleSubmit}>
            {selectedTest.current?.species?.toLowerCase() === "cat" &&
            selectedTest.current?.product_category?.toLowerCase() === "dry"
              ? translate("TESTING.BUTTON.SAVE", intl)
              : translate("TESTING.BUTTON.SUBMIT", intl)}
          </button>
        </div>
      </div>
      <Modal
        isOpen={noResponsesError}
        title={translate("TESTING.GENERAL.SUBMISSION_FAILED", intl)}
        icon="icon-circle-x text-danger font-200"
        action={translate("APP.BUTTON.OK", intl)}
        onClose={() => {
          setNoResponsesError(false);
          history.push("/");
        }}
      />
      {country.toLowerCase() === "usa" && (
        <Modal
          isOpen={retryReward}
          title={translate("TESTING.TOAST.GENERATE_REWARD_LINK", intl)}
          icon="icon-circle-x text-danger font-200"
          disable={true}
          action={
            <button
              className="btn btn-primary"
              onClick={() => {
                if (retryObj) {
                  tryRewardFetch(retryObj); // Try again using saved params
                }
              }}
              disabled={retrying}
            >
              {retrying
                ? translate("APP.BUTTON.RETRYING", intl)
                : translate("APP.BUTTON.RETRY", intl)}
            </button>
          }
          onClose={() => {
            // Optional: prevent closing until success
            setRetryReward(true);
          }}
        />
      )}
      <Modal
        isOpen={isOpen}
        action={
          country.toLowerCase() === "usa"
            ? translate("APP.BUTTON.RR", intl)
            : translate("TESTING.BUTTON.VIEW_SCHEDULE", intl)
        }
        title={translate("TESTING.GENERAL.YOUR_TEST_WAS_SUCCESSFUL", intl)}
        icon="icon-circle-check text-success font-200"
        onClose={() => {
          const species = selectedTest.species?.toLowerCase();
          const category = selectedTest.product_category?.toLowerCase();

          dispatch(
            trackingLog(
              {
                ...trackingPayload,
                redirected_to_home:
                  species === "cat" && category === "dry" ? 0 : 1,
              },
              false
            )
          );
          dispatch(petsActions.clear());
          dispatch(logsPanelistsActions.clear(trackingPayload));

          if (species === "cat" && category === "dry") {
            history.push("/testing/postfeed-questionnaire");
          }
          if (country.toLowerCase() === "usa") {
            window.open(rewardURL, "_blank");
            history.replace("/");
          } else {
            history.replace("/");
          }
        }}
      />
      <RedirectModel history={history} isOpen={open} />
    </div>
  );
}

export default injectIntl(Finish);
